import { ILegalClient } from '../ILegalClient';
import { LegalTransactionRelationshipRoleEnum } from './LegalTransactionRelationshipRoleEnum';
import { IMemberChild } from './Members/IMemberChild';
import { IMemberInheritor } from './Members/IMemberInheritor';
import { IMemberParent } from './Members/IMemberParent';
import { IMemberParticipant } from './Members/IMemberParticipant';
import { IMemberSigner } from './Members/IMemberSigner';
import { IMemberSpouse } from './Members/IMemberSpouse';
import { IMemberTestator } from './Members/IMemberTestament';

export type ILegalTransactionRelationshipMember =
  | IMemberChild
  | IMemberInheritor
  | IMemberParent
  | IMemberParticipant
  | IMemberSigner
  | IMemberSpouse
  | IMemberTestator;

export type MemberByRole<T extends LegalTransactionRelationshipRoleEnum> =
  Extract<ILegalTransactionRelationshipMember, { idRelationshipRole: T }>;

export type ILegalTransactionRelationshipMemberSkeleton = Omit<
  ILegalTransactionRelationshipMember,
  'idRelationshipRole' | 'data'
>;

export const getEmptyMemberSkeleton = (
  legalClient: ILegalClient,
  idRelationship: number
): ILegalTransactionRelationshipMemberSkeleton => {
  return {
    idLegalClient: legalClient.idLegalClient,
    idRelationship,
    idLegalClientRelationship: -1,
    isActiveLegalClientRelationship: true,
    FirstName: legalClient.FirstName ?? null,
    LastName: legalClient.LastName ?? null,
    LegalClient: {} as ILegalClient, // DEPRECATED, GET LEGAL CLIENT DATA FROM STORE
  };
};
